export default __webpack_public_path__ + "static/media/blockscout.823a50ae.png";